@if (!accessDenied) {
  <div class="manage-household">
    @if (household) {
      <div class="space-y-6">
        <!-- Danger zone -->
        <div class="border border-error/40 bg-error/10 rounded-lg p-4">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <div class="text-xs font-bold uppercase tracking-wider text-error mb-1">Danger zone</div>
              @if (household.is_default) {
                <p class="text-sm opacity-70">This is your default household. To delete it, switch your default household first.</p>
              } @else {
                <p class="text-sm opacity-70">Deleting this household will also delete all your products.</p>
              }
            </div>
            @if (!household.is_default) {
              <ui-button
                [variant]="'danger'"
                size="sm"
                (clicked)="openDeleteHouseholdModal()"
                [disabled]="deletingHousehold"
                [loading]="deletingHousehold"
              >
                Delete household
              </ui-button>
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="alert alert-error">
    You don't have access to this household.
  </div>
}
